import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PlusCircleSVG = function PlusCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M25.9 6.1a14 14 0 100 19.8 14 14 0 000-19.8zM23.1 17H17v6a1 1 0 11-2 0v-6H9a1 1 0 010-2h6V9a1 1 0 012 0v6h6a1 1 0 010 2z"
  }));
};
PlusCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PlusCircleSVG);